import { ReactElement } from 'react';

import { Col, ColProps, Row } from 'antd';

import Carousel from '@/components/shared/Carousel';
import styled, { css } from '@/styled';

import { AspectRatioTypes } from '../ImageRatio';
import SkeletonBaseCard from '../SkeletonBaseCard';

interface IProps {
  className?: string;
  children?: ReactElement[] | ReactElement;
  title: string | ReactElement;
  carouselProps: {
    id?: string;
    slidesToShow: number;
    spaceBetween?: number;
  };
  shelfProps: {
    index?: number;
    isFetching?: boolean;
    skeletonAspectRatio?: AspectRatioTypes;
    withBorder?: boolean;
  };
}

const DEFAULT_COLUMNS_WIDTH: Pick<ColProps, 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'> = {
  xs: 24,
  sm: 12,
  md: 12,
  lg: 8,
  xl: 6,
  xxl: 6
};

const Shelf = ({ carouselProps, shelfProps, ...props }: IProps) => {
  if (shelfProps.isFetching)
    return (
      <Row gutter={[16, 16]}>
        {Array.from(Array(4).keys()).map(key => (
          <Col {...DEFAULT_COLUMNS_WIDTH} key={key}>
            <SkeletonBaseCard aspect={shelfProps.skeletonAspectRatio || '16:9'} />
          </Col>
        ))}
      </Row>
    );

  return (
    <div className={props.className}>
      <div className='showcaseShelf-title'>{props.title}</div>
      <Carousel index={shelfProps.index} {...carouselProps}>
        {props.children}
      </Carousel>
    </div>
  );
};

export default styled(Shelf)(
  ({ theme, shelfProps: { withBorder } }) => css`
    .showcaseShelf-title {
      ${withBorder && `border-bottom: 1px solid ${theme.palette.alpha(theme.palette.gray[0], 0.12)}`};
      height: ${withBorder ? 42 : 24}px;
      margin-bottom: ${theme.space.spacing(6)};
      display: flex;
      align-items: center;
      & > h4 {
        font-weight: 400;
      }
    }

    & h3,
    h4 {
      margin: 0;
    }

    & a.ant-typography {
      min-width: 60px;
      margin-left: ${theme.space.spacing(6)};
    }
  `
);
